// Function that agroup an array of items, pass array and group size

const handleCardAgroup = (array: any[], group_quantity: number) => {
    let agroup: any[] = []
    array.forEach((item, index) => {

        if (((index + 1) % group_quantity) === 0) {

            let itemsList = array.slice((index + 1) - group_quantity, index + 1)
            agroup.push(itemsList)

        } else if (((index + 1) % group_quantity) !== 0) {

            let leftItems = (index + 1) % group_quantity
            let itemsList = array.slice((index + 1) - leftItems, index + 1)
            if ((index + 1) === array.length) {
                agroup.push(itemsList)
            }
        }
    })

    return agroup
}

export default handleCardAgroup